import Vue from 'vue'
import Router from 'vue-router'

import ProgressBar from '@shared/progress-bar/progress-bar'

import Layout from './components/Layout.vue'

import HomeView from './views/Home.vue'
import TeamRegistrationView from './views/TeamRegistration.vue'
import Error404View from './views/Error404.vue'

const router = new Router({
  routes: [
    {
      path: '/:slug?',
      component: Layout,
      children: [{
        path: '',
        name: 'home',
        component: HomeView,
      }, {
        path: 'register',
        name: 'teamRegistration',
        component: TeamRegistrationView,
      }]
    },
    {
      path: '*',
      component: Error404View
    }
  ]
})

router.beforeEach((to, from, next) => {
  if (to.name) ProgressBar.start()
  next()
});

router.afterEach(() => {
  ProgressBar.done()
});

Vue.use(Router)

export default router